export default __webpack_public_path__ + "static/media/34.94f4da26.svg";